import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { request } from "@/api-connectors/basicRequests";
import { popToast } from "@/functions/baseToast";
import axios from "axios";

export const uploadFileApi = async (formData: FormData): Promise<any> => {
    return await request<any>({
        method: 'POST',
        route: 'files',
        body: formData
    })
}

export const dataURLtoFile = async (url: string, filename: string): Promise<File | undefined> => {
    return await fetch(url)
        .then((res) => res.blob())
        .then((blob) => new File([blob], filename, { type: "image/png" }));
};

export const serveFile = (fileBlob: Blob, fileName: string): void => {
    const fileURL = window.URL.createObjectURL(fileBlob);
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);

    document.body.appendChild(fileLink);
    fileLink.click();
}

export const downloadFileApi = async (params: {
    fileName?: string | undefined,
    fileRoute: string | undefined
}): Promise<void> => {
    const { fileRoute, fileName } = params

    if (!fileRoute) return

    const fileData = (await axios.get<Blob>(fileRoute, { responseType: 'blob' }))?.data

    if (!fileData) {
        popToast({
            message: 'Fehler beim Dateidownload',
            color: ION_VARIANT.DANGER
        });
        return
    }

    serveFile(new Blob([fileData]), fileName ?? `download-${Date.now()}`)
}
